import React, { useState } from "react";
import { Button } from "semantic-ui-react";
import { useNavigate } from "react-router-dom";
import {
  admin_update_email,
  admin_update_password,
} from "../../../apis/Account.jsx";
import PasswordInput from "./PasswordInput.jsx";

const MyAccount = () => {
  const navigate = useNavigate();
  const storedEmail = localStorage.getItem("email") || "";

  // Email change form
  const [emailForm, setEmailForm] = useState({
    new_email: "",
    current_password: "",
  });
  const [emailBusy, setEmailBusy] = useState(false);

  // Password change form
  const [pwForm, setPwForm] = useState({
    current_password: "",
    new_password: "",
    confirm_password: "",
  });
  const [pwBusy, setPwBusy] = useState(false);

  const onEmailSubmit = async (e) => {
    e.preventDefault();
    if (emailBusy) return;
    if (!emailForm.new_email || !emailForm.current_password) return;
    if (emailForm.new_email.trim().toLowerCase() === storedEmail.toLowerCase()) {
      window.alert("New email must differ from the current email.");
      return;
    }
    setEmailBusy(true);
    const res = await admin_update_email({
      current_email: storedEmail,
      current_password: emailForm.current_password,
      new_email: emailForm.new_email.trim(),
    });
    if (res?.status) {
      localStorage.setItem("email", emailForm.new_email.trim());
      setEmailForm({ new_email: "", current_password: "" });
    }
    setEmailBusy(false);
  };

  const onPwSubmit = async (e) => {
    e.preventDefault();
    if (pwBusy) return;
    const { current_password, new_password, confirm_password } = pwForm;
    if (!current_password || !new_password || !confirm_password) return;
    if (new_password.length < 8) {
      window.alert("New password must be at least 8 characters.");
      return;
    }
    if (new_password !== confirm_password) {
      window.alert("New password and confirmation do not match.");
      return;
    }
    if (new_password === current_password) {
      window.alert("New password must differ from the current password.");
      return;
    }
    setPwBusy(true);
    const res = await admin_update_password({
      current_email: storedEmail,
      current_password,
      new_password,
    });
    if (res?.status) {
      setPwForm({
        current_password: "",
        new_password: "",
        confirm_password: "",
      });
      // For safety: force re-login so any stale session is replaced by a
      // fresh one authenticated with the new credential.
      window.alert(
        "Password changed. You will be logged out so you can sign in again."
      );
      navigate("/logoutAdmin");
    }
    setPwBusy(false);
  };

  return (
    <div className="right-nav" id="dash-event">
      <div className="modal-content">
        <div className="modal-header">
          <h4 className="modal-title">My Account</h4>
        </div>
        <div className="modal-body">
          <p style={{ fontSize: 13, color: "#64748b", marginBottom: 20 }}>
            Signed in as <strong>{storedEmail || "(unknown)"}</strong>. You must
            re-enter your current password to confirm any change.
          </p>

          <div className="row">
            {/* Update email */}
            <div className="col-md-6">
              <div
                style={{
                  border: "1px solid #e2e8f0",
                  borderRadius: 8,
                  padding: 20,
                  marginBottom: 24,
                }}
              >
                <h5 style={{ marginBottom: 16 }}>Change email</h5>
                <form onSubmit={onEmailSubmit}>
                  <div className="form-group" style={{ marginBottom: 12 }}>
                    <label>Current email</label>
                    <input
                      type="email"
                      className="form-control"
                      value={storedEmail}
                      disabled
                    />
                  </div>
                  <div className="form-group" style={{ marginBottom: 12 }}>
                    <label>New email *</label>
                    <input
                      type="email"
                      className="form-control"
                      placeholder="new@example.com"
                      value={emailForm.new_email}
                      onChange={(e) =>
                        setEmailForm((p) => ({
                          ...p,
                          new_email: e.target.value,
                        }))
                      }
                      autoComplete="off"
                      disabled={emailBusy}
                    />
                  </div>
                  <div className="form-group" style={{ marginBottom: 16 }}>
                    <label>Current password *</label>
                    <PasswordInput
                      placeholder="Enter current password"
                      value={emailForm.current_password}
                      onChange={(e) =>
                        setEmailForm((p) => ({
                          ...p,
                          current_password: e.target.value,
                        }))
                      }
                      autoComplete="current-password"
                      disabled={emailBusy}
                    />
                  </div>
                  <Button
                    type="submit"
                    className="btn btn-primary"
                    disabled={
                      emailBusy ||
                      !emailForm.new_email.trim() ||
                      !emailForm.current_password
                    }
                  >
                    Update email
                  </Button>
                </form>
              </div>
            </div>

            {/* Update password */}
            <div className="col-md-6">
              <div
                style={{
                  border: "1px solid #e2e8f0",
                  borderRadius: 8,
                  padding: 20,
                  marginBottom: 24,
                }}
              >
                <h5 style={{ marginBottom: 16 }}>Change password</h5>
                <form onSubmit={onPwSubmit}>
                  <div className="form-group" style={{ marginBottom: 12 }}>
                    <label>Current password *</label>
                    <PasswordInput
                      value={pwForm.current_password}
                      onChange={(e) =>
                        setPwForm((p) => ({
                          ...p,
                          current_password: e.target.value,
                        }))
                      }
                      autoComplete="current-password"
                      disabled={pwBusy}
                    />
                  </div>
                  <div className="form-group" style={{ marginBottom: 12 }}>
                    <label>New password *</label>
                    <PasswordInput
                      placeholder="At least 8 characters"
                      value={pwForm.new_password}
                      onChange={(e) =>
                        setPwForm((p) => ({
                          ...p,
                          new_password: e.target.value,
                        }))
                      }
                      autoComplete="new-password"
                      disabled={pwBusy}
                    />
                  </div>
                  <div className="form-group" style={{ marginBottom: 16 }}>
                    <label>Confirm new password *</label>
                    <PasswordInput
                      value={pwForm.confirm_password}
                      onChange={(e) =>
                        setPwForm((p) => ({
                          ...p,
                          confirm_password: e.target.value,
                        }))
                      }
                      autoComplete="new-password"
                      disabled={pwBusy}
                    />
                  </div>
                  <Button
                    type="submit"
                    className="btn btn-primary"
                    disabled={
                      pwBusy ||
                      !pwForm.current_password ||
                      !pwForm.new_password ||
                      !pwForm.confirm_password
                    }
                  >
                    Update password
                  </Button>
                  <p
                    style={{
                      fontSize: 12,
                      color: "#94a3b8",
                      marginTop: 12,
                      marginBottom: 0,
                    }}
                  >
                    After changing your password, you'll be signed out and need
                    to log in again with the new password.
                  </p>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MyAccount;
